import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { injectIntl } from '../../../../util/reactIntl';
import { useConfiguration } from '../../../../context/configurationContext';
import css from './GearMarketplaceSection.module.css';
import Tile from '../Tile/Tile';
import Button from '../Button/Button';
import { getRandomProducts } from '../../utils';
import { createSlug } from '../../../../util/urlHelpers';
import { formatMoney } from '../../../../util/currency';

const GearMarketplaceSectionComponent = props => {
  const { intl } = props;
  const config = useConfiguration();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    getRandomProducts(5)
      .then(listings => {
        setProducts(listings);
        setLoading(false);
      })
      .catch(e => {
        console.error('Error loading products:', e);
        setLoading(false);
      });
  }, []);

  const getProductImage = (listing) => {
    const image = listing.images && listing.images[0];
    if (image?.attributes?.variants) {
      return image.attributes.variants['listing-card']?.url || 
             image.attributes.variants['default']?.url || 
             '/static/img/rectangle-4-10.svg';
    }
    return '/static/img/rectangle-4-10.svg';
  };

  const getProductPrice = (listing) => {
    if (listing.attributes?.price) {
      return formatMoney(intl, listing.attributes.price);
    }
    return '£0.00';
  };

  const getProductSport = (listing) => {
    const sport = listing.attributes?.publicData?.sport || 'Martial Arts';
    // Capitalize first letter
    return sport.charAt(0).toUpperCase() + sport.slice(1).toLowerCase();
  };

  const handleProductClick = (listing) => {
    const slug = createSlug(listing.attributes.title);
    history.push(`/l/${slug}/${listing.id.uuid}`);
  };

  return (
    <div className={css.section}>
      <div className={css.header}>
        <p className={css.title}>
          Affordable Martial Arts Equipment from the Community
        </p>

        <p className={css.description}>
          Browse our growing selection of brand new and second-hand martial
          arts gear, from beginner-friendly uniforms to professional training
          equipment.
        </p>
      </div>

      {loading ? (
        <div className={css.loadingContainer}>
          <p className={css.loadingText}>Loading products...</p>
        </div>
      ) : (
        <div className={css.tilesContainer}>
          {products.map(listing => (
            <Tile
              key={listing.id.uuid}
              variant="portrait"
              image={getProductImage(listing)}
              title={listing.attributes?.title || 'Product'}
              category={getProductSport(listing)}
              price={getProductPrice(listing)}
              onClick={() => handleProductClick(listing)}
            />
          ))}
        </div>
      )}

      <div className={css.buttonWrapper}>
        <Button
          variant="primary"
          text="Browse all gear"
          onClick={() => history.push('/product?pub_listingType=product-selling')}
        />
      </div>
    </div>
  );
};

export default injectIntl(GearMarketplaceSectionComponent);

